import React from 'react';
import { Button } from '../ui/Button';
import { SelectField, TextAreaField, TextField } from '../ui/Field';
import { FormCard, FormError, FormFooterNote, FormSuccess } from './FormShell';
import { useLeadSubmit } from '../../hooks/useLeadSubmit';
export function PermutaForm({
  vehiculoInteres = ''
}: {
  vehiculoInteres?: string;
}) {
  const {
    status,
    sending,
    submitted,
    reference,
    submitForm,
    retry
  } = useLeadSubmit('permuta', 'Permuta');
  if (submitted) {
    return <FormSuccess message="Gracias por tu consulta. Un asesor de VCARS se comunicará con vos a la brevedad." reference={reference} data-id="element-127" data-mp="14sl0kadph9b4" />;
  }
  return <FormCard title="Contanos qué vehículo entregás" lead="Evaluamos tu usado y te decimos cuánto lo tomamos como parte de pago de tu próxima compra." data-id="element-128" data-mp="zv1onh4hd8mc">
      {status === 'error' ? <FormError onRetry={retry} data-id="element-129" data-mp="2u55azz7yk2bi" /> : null}
      <form className="grid gap-4 sm:grid-cols-2" onSubmit={submitForm} data-id="element-130" data-mp="2q54khg7l40o3">
        <TextField id="nombre" label="Nombre" required autoComplete="name" data-id="element-131" data-mp="3mosnoeqj35ia" />
        <TextField id="telefono" label="Teléfono" type="tel" required autoComplete="tel" data-id="element-132" data-mp="3mqvlhkxxa2xk" />
        <TextField id="marca" label="Marca del vehículo" required data-id="element-133" data-mp="3rp6xo2bowpiy" />
        <TextField id="modelo" label="Modelo" required data-id="element-134" data-mp="3dp5wsmvfdi3h" />
        <TextField id="version" label="Versión" placeholder="Ej: Allure 1.6" data-id="element-135" data-mp="3hpprljsj09mg" />
        <TextField id="anio" label="Año" type="number" min={1980} max={2027} required data-id="element-136" data-mp="3hrsf9x67hqo0" />
        <TextField id="kilometraje" label="Kilometraje" type="number" min={0} required data-id="element-137" data-mp="9ao7uj3j31x9" />
        <TextField id="montoEstimado" label="Monto estimado que pretendés por tu auto" required placeholder="Ej: USD 12.000 o $14.500.000" data-id="element-138" data-mp="e8hch7p6nnvf" />
        <SelectField id="estadoGeneral" label="Estado general" options={['Excelente', 'Muy bueno', 'Bueno', 'A reacondicionar']} required data-id="element-139" data-mp="4hv33v827tl6" />
        <TextField id="vehiculoInteres" label="Vehículo que te interesa" defaultValue={vehiculoInteres} placeholder="Ej: Ford Ranger Limited 0KM" data-id="element-140" data-mp="wzqq9t5zkyst" />
        <TextAreaField id="mensaje" label="Mensaje" className="sm:col-span-2" placeholder="Detalles del vehículo, service al día, detalles de chapa o pintura…" data-id="element-141" data-mp="12tm33cigpabb" />
        <div className="sm:col-span-2" data-id="element-142" data-mp="sumtnrpvhan9">
          <Button type="submit" size="lg" className="w-full sm:w-auto" disabled={sending} data-id="element-143" data-mp="sxskbbe5gkl3">
            {sending ? 'Enviando consulta…' : 'Tengo una permuta'}
          </Button>
          <FormFooterNote data-id="element-144" data-mp="j4bpq566v1gd">
            Evaluación rápida y sin compromiso. Usados seleccionados y oportunidades reales.
          </FormFooterNote>
        </div>
      </form>
    </FormCard>;
}